import React from 'react';
import { ExportTypes } from '@shared/utils/constants';
import InvoicesExport from './InvoicesExport';

const ExportForm = ({
	type,
}: {
	type: ExportTypes;
}) => {
	let component = (<></>);

	switch (type) {
		case ExportTypes.ACCRUALS:
			component = (<InvoicesExport />);
			break;
		default:
			component = (
				<>
					<b>Could not export selected type</b>
				</>
			);
			break;
	}

	return component;
};

export default ExportForm;
